export default __webpack_public_path__ + "static/media/Web 1280 ΓÇô 26.78dd7187.jpg";